/**
 * Created by taoyiling on 16/10/08.
 */


import suid from '../../services/suid';


export default {
    name: 'KsSliderBar',
    props: {
        max: {
            type: Number,
            required: true,
            default: 0
        },
        min: {
            type: Number,
            required: true,
            default: 0
        },
        step: {
            type: Number,
            required: true,
            default: 1
        },
        value: {
            // type: String,
            required: true,
            default: ""
        },
        unit: {
            type: String,
            required: true,
            default: 'Mbps'
        }

    },
    watch: {
        value() {
            this.maxWidth = $(this.$el).find('.ks-drag-box').get(0).offsetWidth - 16;
            this.valueNumber = parseInt(this.value);
        },
        valueNumber(){
            this.maxWidth = $(this.$el).find('.ks-drag-box').get(0).offsetWidth - 16;
            this.valueNumber = parseInt(this.valueNumber);
            if (isNaN(this.valueNumber)) {
                // this.valueNumber = this.min;
                this.valueNumber = '';
                $('.progress').css('width', 0)
            } else if (this.valueNumber > this.max) {
                this.valueNumber = this.max;
                $('.progress').css('width', this.maxWidth)
            } else if (this.valueNumber <= this.min) {
                this.valueNumber = this.min;
                $('.progress').css('width', 0)
            } else {
                $('.progress').css('width', ((this.valueNumber - this.min) / (this.max - this.min)) * this.maxWidth)
                //console.log($('.progress').width(),1111)
            }

            this.$emit('input', this.valueNumber + '');
            //this.value = this.valueNumber + '';
        },
        min(){
            this.percent = (1 / (this.max - this.min)).toFixed(6);
        },
        max(){
            this.percent = (1 / (this.max - this.min)).toFixed(6);
        },
        step(){
            this.percent = (1 / (this.max - this.min)).toFixed(6);
        }
    },

    data() {
        return {
            valueNumber: this.value,
            maxWidth: 0,
            boxLeftOffset: 0,
            percent: 0,
            widthPercent: 0,
            widthD: 0
        };
    },

    // updated() {
    //     console.log(this.value);
    // },

    mounted() {
        function getLeft(e) {
            var offset = e.offsetLeft;
            if (e.offsetParent != null) {
                offset += getLeft(e.offsetParent);
            }
            return offset;
        }

        this.$nextTick(() => {
            this.maxWidth = $(this.$el).find('.ks-drag-box').get(0).offsetWidth - 16;
            this.valueNumber = parseInt(this.value);
            if (isNaN(this.valueNumber)) {
                this.valueNumber = this.min;
                $('.progress').css('width', 0)
            } else if (this.valueNumber > this.max) {
                this.valueNumber = this.max;
                $('.progress').css('width', this.maxWidth)
            } else if (this.valueNumber <= this.min) {
                this.valueNumber = this.min;
                $('.progress').css('width', 0)
            } else {
                $('.progress').css('width', ((this.valueNumber - this.min) / (this.max - this.min)) * this.maxWidth)
                //console.log($('.progress').width(),1111)
            }
        });
    },

    methods: {
        mousedownHandler(e){
            e.preventDefault();
            this.boxLeftOffset = $(this.$el).find('.ks-drag-box').offset().left+8;
            this.maxWidth = $(this.$el).find('.ks-drag-box').get(0).offsetWidth - 16;
            this.percent = (1 / (this.max - this.min)).toFixed(6);
            console.log(this.boxLeftOffset,'this.boxLeftOffset')
            $('body').addClass('ks-unselect');

            $('.progress').css('width', e.clientX - this.boxLeftOffset)
            //蓝色部分占整个的百分比
            this.widthPercent = ((e.clientX - this.boxLeftOffset) / this.maxWidth).toFixed(6);
            //value值就是百分比乘以（max-min）
            if (this.widthPercent < 0) {
                this.widthPercent = 0
                // this.value=this.min+'';
                this.$emit('input', this.min + '');
            } else if (this.widthPercent > 1) {
                this.widthPercent = 1;
                //this.value = this.max + '';
                this.$emit('input', this.max + '');
            } else {
                //this.value = (this.widthPercent / this.percent).toFixed(0);
                this.$emit('input', (this.widthPercent / this.percent).toFixed(0));
            }

            // console.log($('.progress').css('width'),this.widthD,this.value)

            document.body.addEventListener('mousemove', this.mousemoveHandler, false);
            document.body.addEventListener('mouseup', this.removemoveHandler, false);
        },
        mousemoveHandler(e){
            //蓝色部分占整个的百分比 
            var offset = e.clientX - this.boxLeftOffset
            // console.log(offset)
            this.widthPercent = ((e.clientX - this.boxLeftOffset) / this.maxWidth).toFixed(6);
            if (this.widthPercent < 0) {
                this.widthPercent = 0
                //this.value = this.min + '';
                this.$emit('input', this.min + '');
            } else if (this.widthPercent > 1) {
                this.widthPercent = 1;
                //this.value = this.max + '';
                this.$emit('input', this.max + '');
            } else {
                var tem = (this.widthPercent / this.percent).toFixed(0);
                if (Math.abs(tem - this.value) >= this.step) {
                    // this.value = tem;
                    this.$emit('input', tem);
                    $('.progress').css('width', offset);
                } else {
                    $('.progress').css('width');
                }
            }

        },
        removemoveHandler(e){
            $('body').removeClass('ks-unselect');
            document.body.removeEventListener('mousemove', this.mousemoveHandler, false);
            document.body.removeEventListener('mouseup', this.removemoveHandler, false);
        },
        _resetValue(e) {
            this.valueNumber = parseInt(this.valueNumber);
            if (isNaN(this.valueNumber)) {
                this.valueNumber = this.min;
                $('.progress').css('width', 0);
            }
        }
    }


};